// import React, { useState } from 'react';

// function Newleadadding({ onClose, accessToken, userDetails }) {
//   const [formData, setFormData] = useState({
//     customerName: '',
//     phoneNumber: '',
//     fromAddress: '',
//     toAddress: '',
//     OriginCity: '',
//     destination: '',
//     email: ''
//   });

//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (loading) return; 
//     setLoading(true);

//     const payload = {
//       OriginCity: formData.OriginCity,
//       Customer_Name: formData.customerName,
//       DestinationCity: formData.destination,
//       FromAddress: formData.fromAddress,
//       ToAddress: formData.toAddress,
//       Email: formData.email,
//       Phone_Number: formData.phoneNumber
//     };

//     try {
//       const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/leadsdata", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${accessToken}`
//         },
//         body: JSON.stringify(payload)
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         console.error("Error:", result);
//         alert(result.message || "Failed to submit lead.");
//       } else {
//         console.log("Success:", result);
//         alert(result.message || "Lead submitted successfully!");
//         onClose();
//       }
//     } catch (error) {
//       console.error("Network error:", error);
//       alert("An error occurred while submitting the form.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div 
//       className="new-lead-overlay" 
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0,0,0,0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 1000,
//         overflow: "auto",
//         padding: "20px"
//       }}
//     >
//       <div 
//         style={{
//           backgroundColor: "white",
//           padding: "20px",
//           borderRadius: "8px",
//           width: "100%",
//           maxWidth: "500px",
//           position: "relative",
//           boxSizing: "border-box"
//         }}
//       >
//         <style>
//           {`
//             @keyframes spin {
//               0% { transform: rotate(0deg); }
//               100% { transform: rotate(360deg); }
//             }
//           `}
//         </style>

//         <button
//           className="close-btn"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             right: "10px",
//             top: "10px",
//             background: "none",
//             border: "none",
//             fontSize: "20px",
//             cursor: "pointer"
//           }}
//         >
//           ✖
//         </button>
//         <h2 style={{ margin: "0 0 20px 0", fontSize: "1.5rem" }}>Create New Lead</h2>

//         {loading ? (
//           <div style={{ textAlign: "center", padding: "20px" }}>
//             <p style={{ fontSize: "1rem", color: "#333" }}>Submitting lead...</p>
//             <div style={{
//               width: "40px",
//               height: "40px",
//               border: "4px solid #ccc",
//               borderTop: "4px solid #007bff",
//               borderRadius: "50%",
//               animation: "spin 1s linear infinite",
//               margin: "10px auto"
//             }}></div>
//           </div>
//         ) : (
//           <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//             {[
//               { label: "Customer Name", name: "customerName", type: "text" },
//               { label: "Phone Number", name: "phoneNumber", type: "tel" },
//               { label: "Origin City", name: "OriginCity", type: "text" },
//               { label: "Destination City", name: "destination", type: "text" },
//               { label: "Email", name: "email", type: "email" }
//             ].map(({ label, name, type }) => (
//               <div key={name} style={{ display: "flex", flexDirection: "column" }}>
//                 <label htmlFor={name} style={{ marginBottom: "4px", fontSize: "0.9rem", fontWeight: "500", color: "#333" }}>
//                   {label}
//                 </label>
//                 <input
//                   type={type}
//                   id={name}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px",
//                     border: "1px solid #ccc",
//                     borderRadius: "4px",
//                     fontSize: "0.9rem",
//                     boxSizing: "border-box"
//                   }}
//                   required
//                 />
//               </div>
//             ))}
//             {[
//               { label: "From Address", name: "fromAddress" },
//               { label: "To Address", name: "toAddress" }
//             ].map(({ label, name }) => (
//               <div key={name} style={{ display: "flex", flexDirection: "column" }}>
//                 <label htmlFor={name} style={{ marginBottom: "4px", fontSize: "0.9rem", fontWeight: "500", color: "#333" }}>
//                   {label}
//                 </label>
//                 <textarea
//                   id={name}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px",
//                     border: "1px solid #ccc",
//                     borderRadius: "4px",
//                     fontSize: "0.9rem",
//                     minHeight: "60px",
//                     resize: "vertical",
//                     boxSizing: "border-box"
//                   }}
//                   required
//                 />
//               </div>
//             ))}
//             {/* <button
//               type="submit"
//               style={{
//                 backgroundColor: "#007bff",
//                 color: "white",
//                 padding: "10px",
//                 border: "none",
//                 borderRadius: "4px",
//                 cursor: "pointer",
//                 fontSize: "0.9rem",
//                 marginTop: "10px"
//               }}
//             >
//               Submit
//             </button> */}
//             <button
//                 type="submit"
//                 disabled={loading}
//                 style={{
//                     backgroundColor: loading ? "#ccc" : "#007bff",
//                     cursor: loading ? "not-allowed" : "pointer",
//                     color: "white",
//                     padding: "10px",
//                     border: "none",
//                     borderRadius: "4px",
//                     fontSize: "0.9rem",
//                     marginTop: "10px"
//                 }}
//                 >
//                 {loading ? "Submitting..." : "Submit"}
//                 </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Newleadadding;
import React, { useState, useEffect, useRef } from 'react';

function Newleadadding({ onClose, accessToken, userDetails }) {
  const [formData, setFormData] = useState({
    customerName: '',
    LeadProviderLeadId: '',
    phoneNumber: '',
    fromAddress: '',
    toAddress: '',
    OriginCity: '',
    destination: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const [moveFromMoveToOptions, setMoveFromMoveToOptions] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [errors, setErrors] = useState({
    OriginCity: '',
    destination: ''
  });
  const [showDropdown, setShowDropdown] = useState({ OriginCity: false, destination: false });
  const [filteredOptions, setFilteredOptions] = useState({ OriginCity: [], destination: [] });
  const [highlightedIndex, setHighlightedIndex] = useState({ OriginCity: -1, destination: -1 });
  const inputRefs = useRef({ OriginCity: null, destination: null });
  const dropdownRefs = useRef({ OriginCity: null, destination: null });

  const formatISTDateTime = () => {
    const date = new Date();
    const pad = (n) => String(n).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const formatESTDateOnly = () => {
    const date = new Date();
    const estDate = new Date(date.toLocaleString("en-US", { timeZone: "America/Toronto" }));

    const pad = (n) => String(n).padStart(2, '0');

    const year = estDate.getFullYear();
    const month = pad(estDate.getMonth() + 1);
    const day = pad(estDate.getDate());

    return `${year}-${month}-${day}`;
  };

  // Fetch dropdown options from API
  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/emailtemp", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("API Response:", JSON.stringify(data, null, 2));

        // Extract records array from response
        const records = data.records;
        if (!Array.isArray(records)) {
          throw new Error("API response 'records' is not an array");
        }

        // Extract unique Move_FromMove_To values
        const uniqueMoveFromMoveTo = [...new Set(
          records
            .filter(item => item.Move_FromMove_To && typeof item.Move_FromMove_To === 'string' && item.Move_FromMove_To.trim() !== '')
            .map(item => item.Move_FromMove_To.trim())
        )].sort();

        console.log("Processed MoveFromMoveTo Options:", uniqueMoveFromMoveTo);

        setMoveFromMoveToOptions(uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"]);
        setFilteredOptions({
          OriginCity: uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"],
          destination: uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"]
        });
        setFetchError(null);
      } catch (error) {
        console.error("Error fetching dropdown options:", error.message);
        setFetchError(error.message);
        setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
        setFilteredOptions({
          OriginCity: ["Mississauga, ON", "Brampton, ON"],
          destination: ["Mississauga, ON", "Brampton, ON"]
        });
      }
    };
    fetchDropdownOptions();
  }, [accessToken]);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(inputRefs.current).forEach((field) => {
        if (
          dropdownRefs.current[field] && !dropdownRefs.current[field].contains(event.target) &&
          inputRefs.current[field] && !inputRefs.current[field].contains(event.target)
        ) {
          setShowDropdown(prev => ({ ...prev, [field]: false }));
          setHighlightedIndex(prev => ({ ...prev, [field]: -1 }));
        }
      });
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const validateCityFormat = (input) => {
    const cityFormatRegex = /^[A-Za-z\s\-.']+,\s[A-Z]{2}$/;
    return cityFormatRegex.test(input);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));

    if (["OriginCity", "destination"].includes(name)) {
      if (value.trim() === "") {
        setFilteredOptions(prev => ({
          ...prev,
          [name]: moveFromMoveToOptions
        }));
        setShowDropdown(prev => ({ ...prev, [name]: true }));
      } else {
        const filtered = moveFromMoveToOptions.filter(option =>
          option.toLowerCase().startsWith(value.toLowerCase())
        );
        setFilteredOptions(prev => ({
          ...prev,
          [name]: filtered
        }));
        setShowDropdown(prev => ({ ...prev, [name]: true }));
      }
      setHighlightedIndex(prev => ({ ...prev, [name]: -1 }));
    }
  };

  const handleOptionSelect = (name, option) => {
    setFormData(prev => ({
      ...prev,
      [name]: option
    }));
    setShowDropdown(prev => ({ ...prev, [name]: false }));
    setHighlightedIndex(prev => ({ ...prev, [name]: -1 }));
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
    if (inputRefs.current[name]) {
      inputRefs.current[name].blur(); // Remove focus to prevent dropdown from reopening
    }
  };

  const handleInputFocus = (name) => {
    setShowDropdown(prev => ({ ...prev, [name]: true }));
    setFilteredOptions(prev => ({
      ...prev,
      [name]: formData[name] ? moveFromMoveToOptions.filter(option =>
        option.toLowerCase().startsWith(formData[name].toLowerCase())
      ) : moveFromMoveToOptions
    }));
  };

  const handleKeyDown = (e, name) => {
    if (!["OriginCity", "destination"].includes(name) || !showDropdown[name]) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex(prev => ({
        ...prev,
        [name]: prev[name] < filteredOptions[name].length - 1 ? prev[name] + 1 : 0
      }));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(prev => ({
        ...prev,
        [name]: prev[name] > 0 ? prev[name] - 1 : filteredOptions[name].length - 1
      }));
    } else if (e.key === "Enter" && highlightedIndex[name] >= 0) {
      e.preventDefault();
      handleOptionSelect(name, filteredOptions[name][highlightedIndex[name]]);
    } else if (e.key === "Escape") {
      setShowDropdown(prev => ({ ...prev, [name]: false }));
      setHighlightedIndex(prev => ({ ...prev, [name]: -1 }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    // Validate OriginCity and DestinationCity
    let hasErrors = false;
    const newErrors = { OriginCity: '', destination: '' };

    if (formData.OriginCity && !validateCityFormat(formData.OriginCity)) {
      newErrors.OriginCity = "Please enter the city in the format 'City name, XX' (e.g., 'Toronto, ON')";
      hasErrors = true;
    }
    if (formData.destination && !validateCityFormat(formData.destination)) {
      newErrors.destination = "Please enter the city in the format 'City name, XX' (e.g., 'Toronto, ON')";
      hasErrors = true;
    }

    setErrors(newErrors);
    if (hasErrors) {
      setLoading(false);
      return;
    }

    const payload = {
      OriginCity: formData.OriginCity,
      Customer_Name: formData.customerName,
      LeadProviderLeadId: formData.LeadProviderLeadId,
      DestinationCity: formData.destination,
      FromAddress: formData.fromAddress,
      ToAddress: formData.toAddress,
      Email: formData.email,
      Phone_Number: formData.phoneNumber,
      Lead_Status: "RECEIVED",
      Received_Time_IST: formatISTDateTime(),
      Received_Date_EST: formatESTDateOnly(),
    };

    try {
      const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/leadsdata", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok) {
        console.error("Error:", result);
        alert(result.message || "Failed to submit lead.");
      } else {
        console.log("Success:", result);
        alert(result.message || "Lead submitted successfully!");
        onClose();
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("An error occurred while submitting the form.");
    } finally {
      setLoading(false);
    }
  };

  console.log("FormData:", formData);
  console.log("Filtered Options:", filteredOptions);

  return (
    <div 
      className="new-lead-overlay" 
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        overflow: "auto",
        padding: "20px"
      }}
    >
      <div 
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "100%",
          maxWidth: "500px",
          position: "relative",
          boxSizing: "border-box"
        }}
      >
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>

        <button
          className="close-btn"
          onClick={onClose}
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer"
          }}
        >
          ✖
        </button>
        <h2 style={{ margin: "0 0 20px 0", fontSize: "1.5rem", color: "#333" }}>Create New Lead</h2>

        {fetchError && (
          <div style={{ color: "red", marginBottom: "10px", fontSize: "0.9rem" }}>
            Error fetching city options: {fetchError}. Using fallback options.
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p style={{ fontSize: "1rem", color: "#333" }}>Submitting lead...</p>
            <div style={{
              width: "40px",
              height: "40px",
              border: "4px solid #ccc",
              borderTop: "4px solid #007bff",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "10px auto"
            }}></div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {[
              { label: "Provider Lead Id", name: "LeadProviderLeadId", type: "text" },
              { label: "Customer Name", name: "customerName", type: "text" },
              { label: "Phone Number", name: "phoneNumber", type: "tel" },
              { label: "Email", name: "email", type: "email" }
            ].map(({ label, name, type }) => (
              <div key={name} style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor={name} style={{ marginBottom: "4px", fontSize: "0.9rem", fontWeight: "500", color: "#333" }}>
                  {label}
                </label>
                <input
                  type={type}
                  id={name}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "0.9rem",
                    boxSizing: "border-box"
                  }}
                  required
                />
              </div>
            ))}
            {[
              { label: "Origin City", name: "OriginCity" },
              { label: "Destination City", name: "destination" }
            ].map(({ label, name }) => (
              <div key={name} style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor={name} style={{ marginBottom: "4px", fontSize: "0.9rem", fontWeight: "500", color: "#333" }}>
                  {label}
                </label>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type="text"
                    id={name}
                    name={name}
                    ref={el => (inputRefs.current[name] = el)}
                    value={formData[name]}
                    onChange={handleChange}
                    onFocus={() => handleInputFocus(name)}
                    onKeyDown={(e) => handleKeyDown(e, name)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "0.9rem",
                      boxSizing: "border-box"
                    }}
                    placeholder="Enter or select city (e.g., Toronto, ON)"
                    required
                  />
                  {showDropdown[name] && filteredOptions[name].length > 0 && (
                    <ul
                      ref={el => (dropdownRefs.current[name] = el)}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        maxHeight: "200px",
                        overflowY: "auto",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        zIndex: 1001
                      }}
                    >
                      {filteredOptions[name].map((option, index) => (
                        <li
                          key={option}
                          onClick={() => handleOptionSelect(name, option)}
                          onMouseEnter={() => setHighlightedIndex(prev => ({ ...prev, [name]: index }))}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            background: highlightedIndex[name] === index ? "#f0f0f0" : "transparent",
                            color: "#333"
                          }}
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {errors[name] && (
                  <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                    {errors[name]}
                  </div>
                )}
              </div>
            ))}
            {[
              { label: "From Address", name: "fromAddress" },
              { label: "To Address", name: "toAddress" }
            ].map(({ label, name }) => (
              <div key={name} style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor={name} style={{ marginBottom: "4px", fontSize: "0.9rem", fontWeight: "500", color: "#333" }}>
                  {label}
                </label>
                <textarea
                  id={name}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "0.9rem",
                    minHeight: "60px",
                    resize: "vertical",
                    boxSizing: "border-box"
                  }}
                  required
                />
              </div>
            ))}
            <button
              type="submit"
              disabled={loading}
              style={{
                backgroundColor: loading ? "#ccc" : "#007bff",
                cursor: loading ? "not-allowed" : "pointer",
                color: "white",
                padding: "10px",
                border: "none",
                borderRadius: "4px",
                fontSize: "0.9rem",
                marginTop: "10px"
              }}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Newleadadding;